export type TourStep = {
    target: string;
    title: string;
    body: string;
    selectBanner?: string;
};

export const TOUR_STEPS: TourStep[] = [
    {
        target: 'ajuda',
        title: 'Bem-vindo ao gerador',
        body: 'Já deixamos um exemplo pronto na prévia. Você só troca pelos seus dados. Toque em Próximo para ver cada parte com calma.',
    },
    {
        target: 'foto',
        title: '1. Foto de perfil',
        body: 'Envie sua foto. Ela fica no topo, colada nas bordas, com 100% da largura e altura automática. Sem margem e sem recorte em círculo.',
    },
    {
        target: 'fundo',
        title: '2. Fundo da página',
        body: 'A cor de fundo é obrigatória. A imagem de fundo é opcional: se enviar, ela cobre a tela; se não, vale só a cor.',
    },
    {
        target: 'banners',
        title: '3. Seus banners',
        body: 'Cada retângulo é um botão da bio. Use Adicionar para criar, as setas para reordenar e a lixeira para apagar. Toque em um item para editá-lo.',
    },
    {
        target: 'titulo',
        title: '4. Título do banner',
        body: 'Escreva o texto, escolha esquerda, centro ou direita e ajuste o tamanho. A fonte é sempre Anton — a mesma em todos os banners.',
        selectBanner: 'exemplo-whatsapp',
    },
    {
        target: 'cores',
        title: '5. Cores',
        body: 'Cor do banner e cor do texto. A prévia do celular atualiza na hora. No exemplo, WhatsApp é verde, Instagram rosa e o cupom dourado.',
        selectBanner: 'exemplo-whatsapp',
    },
    {
        target: 'link',
        title: '6. Link',
        body: 'Cole o endereço que abre ao tocar no banner: WhatsApp, Instagram, site, cardápio. Use o endereço completo, começando com https://',
        selectBanner: 'exemplo-whatsapp',
    },
    {
        target: 'cupom',
        title: '7. Cupom',
        body: 'No terceiro banner do exemplo o cupom já está ligado. A pessoa toca, vê o código VIBE10, copia e vai para o site. Você personaliza marca, desconto e cores da janela.',
        selectBanner: 'exemplo-cupom',
    },
    {
        target: 'espaco',
        title: '8. Espaçamento e borda',
        body: 'Abra “Espaçamento e borda” para mudar margens, padding, altura e arredondamento. Não precisa mexer nisso no começo — os padrões já ficam bons.',
        selectBanner: 'exemplo-instagram',
    },
    {
        target: 'preview',
        title: '9. Prévia no celular',
        body: 'É assim que a página aparece no telefone. Toque num banner da prévia para selecioná-lo. No banner de cupom, a janela do código também abre.',
    },
    {
        target: 'download',
        title: '10. Baixar o ZIP',
        body: 'Quando gostar do resultado, baixe o ZIP. Depois é só arrastar a pasta no Netlify Drop — o ebook ensina esse passo com prints.',
    },
];
